<template>
  <MainLayout>
    <v-layout style="padding: 1em" justify-center row fill-height>
      <v-flex>
        <v-card style="height: 100%" light color="#f4f4fa">
          <v-layout column style="height: 100%">
            <!-- Title -->
            <v-card-title row>
              <span class="title font-weight-light">Categories</span>
            </v-card-title>

            <!-- Actions -->
            <div class="d-flex justify-end align-center px-4">
              <v-text-field
                label="Search by id, name"
                class="flex-none mr-2"
                style="width: 40%"
                v-model="filters.q"
                prepend-icon="search"
                clearable
                @input="getCategories"
              />

              <v-space />

              <v-btn
                v-if="isEditable"
                class="flex-none"
                color="primary"
                @click="showNewCategoryForm"
              >
                <v-icon>add</v-icon>
                Add Category
              </v-btn>
            </div>

            <!-- Table -->
            <v-container fluid fill-height class="full-height">
              <v-layout style="padding: 0" class="full-height">
                <v-flex sm12 md12 class="full-height scroll">
                  <v-data-table
                    :headers="headers"
                    :items="categories"
                    :loading="loading"
                    :pagination.sync="pagination"
                    :rows-per-page-items="[10, 50, 100]"
                    :total-items="pagination.totalItems"
                    @update:pagination="getCategories"
                    class="elevation-1"
                  >
                    <!-- When items = [] -->
                    <template v-slot:no-data>
                      <div style="text-align: center">
                        {{
                          loading
                            ? "Please wait a moment "
                            : "No matching records found"
                        }}
                      </div>
                    </template>

                    <!-- When items = undefined -->
                    <template v-slot:no-results>
                      <div style="text-align: center">
                        {{
                          loading
                            ? "Please wait a moment "
                            : "Data will be displayed in here"
                        }}
                      </div>
                    </template>

                    <!-- Data -->
                    <template v-slot:items="props">
                      <td>{{ props.index + 1 }}</td>
                      <td>{{ props.item.name }}</td>
                      <td>
                        {{
                          props.item.department && props.item.department.name
                        }}
                      </td>
                      <td>
                        <v-img
                          v-if="props.item.icon"
                          style="max-height: 2.25em; max-width: 2.25em; margin: 0.375em"
                          :src="props.item.icon"
                        />
                      </td>
                      <td>
                        {{ props.item.total_issues }}
                      </td>
                      <td>
                        {{ props.item.created_at | dateTime }}
                      </td>

                      <!-- Actions -->
                      <td v-if="isEditable">
                        <v-btn @click="editItem(props.item)" icon title="Edit">
                          <v-icon color="warning">edit</v-icon>
                        </v-btn>

                        <v-btn
                          @click="removeItem(props.item)"
                          icon
                          title="Remove"
                        >
                          <v-icon color="error">delete</v-icon>
                        </v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Create Utility Dialog -->
    <v-dialog v-if="showDialog" v-model="showDialog" width="37.5em">
      <v-flex sm12 md12 class="full-height scroll">
        <!-- Header -->
        <v-toolbar color="primary" dark>
          <v-toolbar-title>
            {{
              form.id ? "Edit Category" : "Create New Category"
            }}</v-toolbar-title
          >
          <v-spacer />
          <v-btn icon @click="showDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <!-- Content -->
        <v-card light>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <!-- Name -->
              <div class="form-item-view">
                <strong class="form-item-label">Category Name</strong>
                <v-text-field
                  style="flex: 1"
                  v-model="form.name"
                  :error-messages="errors.name"
                  :rules="[rules.alphabet]"
                  placeholder="Enter Category Name"
                />
              </div>

              <!-- Icon -->
              <div class="form-item-view">
                <strong class="form-item-label">Icon</strong>
                <v-img
                  v-if="form.icon"
                  style="max-width: 2.25em; max-height: 2.25em; margin: 0.375em"
                  :src="form.icon"
                />
                <v-progress-circular
                  v-else-if="iconUploading"
                  indeterminate
                  color="primary"
                />

                <ImageUploader
                  accept="image/png, image/jpg"
                  @input="uploadImage"
                />

                <v-icon v-if="form.icon" @click="form.icon = undefined"
                  >close</v-icon
                >
              </div>

              <!-- Department -->
              <div class="form-item-view">
                <strong class="form-item-label">Department</strong>
                <v-select
                  style="flex: 1"
                  :items="departments"
                  item-text="name"
                  item-value="id"
                  placeholder="Select Department"
                  :error-messages="errors.department_id"
                  v-model="form.department_id"
                  @change="updateDesignation"
                />
              </div>

              <!-- Submit -->
              <div class="form-item-view">
                <div
                  style="display: flex; width: 100%; justify-content: flex-end"
                >
                  <v-btn :disabled="natureLoading" @click="cancel">
                    Cancel
                  </v-btn>
                  <v-btn
                    :loading="updateLoading"
                    :disabled="natureLoading"
                    color="primary"
                    @click="submitForm"
                    >SUBMIT</v-btn
                  >
                </div>
              </div>

              <div
                class="form-item-view py-2"
                style="border-top: 1px solid rgba(0, 0, 0, 0.2)"
              />

              <!-- Category Natures Management -->
              <div class="form-item-view font-weight-bold">
                CATEGORY NATURES
              </div>
              <div class="form-item-view caption">
                (Natures will be updated directly to category without
                submitting)
              </div>

              <ManageableList
                style="width: 100%; min-height: 5em"
                :loading="natureLoading"
                :items="
                  form.complaint_nature_ids.map(
                    id => currentCategoryComplaintNatures[id].name
                  )
                "
                @add="onAddComplaintNature"
                @edit="onEditComplaintNature"
                @remove="onRemoveComplaintNature"
              />
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-dialog>
  </MainLayout>
</template>

<script>
import ManageableList from "@/components/ManageableList";
import moment from "moment";
import api from "@/api/index";
import ImageUploader from "@/components/ImageUploader";
import { mapState } from "vuex";
import { PLATFORMS } from "@/constants/platforms";

import { clearObject, toDictionary } from "@/utils/Object";

import { debounce } from "@/utils/Debounce";

export default {
  metaInfo: {
    title: "Categories",
    meta: [{ name: "Categories", content: "utilities, categories management" }]
  },

  components: {
    ManageableList,
    ImageUploader
  },

  data() {
    return {
      updateLoading: false,
      showDialog: false,
      iconUploading: false,
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: null,
        totalItems: 0
      },
      form: {
        id: undefined,
        department_id: undefined,
        name: undefined,
        icon: undefined,
        complaint_nature_ids: []
      },
      rules: {
        alphabet: value =>
          isNaN(Number(value)) || "Name must includes at least one letter."
      },
      errors: {},
      filters: {
        q: undefined
      },
      loading: false,
      categories: undefined,
      departments: [],
      natureLoading: false,
      complaintNatures: [],
      currentCategoryComplaintNatures: {}
    };
  },

  computed: {
    ...mapState("auth", ["currentUser"]),

    isEditable() {
      return this.currentUser.platform == PLATFORMS.ADMINISTRATION;
    },

    headers() {
      const result = [
        {
          text: "ID",
          width: 100,
          sortable: false
        },
        {
          text: "Name",
          sortable: false
        },
        {
          text: "Department",
          sortable: false
        },
        {
          text: "Icon",
          width: 100,
          sortable: false
        },
        {
          text: "Total Issues",
          width: 50,
          sortable: false
        },
        {
          text: "Created At",
          width: 200,
          sortable: false
        }
      ];

      if (this.isEditable) {
        result.push({
          text: "Action",
          sortable: false
        });
      }

      return result;
    }
  },

  mounted() {
    this.getDepartments();
  },

  methods: {
    convertTime(utcStr) {
      return moment
        .parseZone(utcStr, "YYYY-MM-DD HH:mm:ss", "UTC")
        .toDate()
        .toLocaleTimeString();
    },

    convertDate(utcStr) {
      return moment
        .parseZone(utcStr, "YYYY-MM-DD HH:mm:ss", "UTC")
        .toDate()
        .toLocaleDateString();
    },

    updateDesignation(dpId) {
      let department = this.departments.find(val => val.id === dpId);
      if (department) {
        this.positions = department.positions;
      }
    },

    cancel() {
      this.deleteUncommitedComplaintNatures();
      this.resetForm();
      this.showDialog = false;
    },

    resetForm() {
      clearObject(this.form);

      this.currentCategoryComplaintNatures = {};
    },

    submitForm() {
      this.errors = {};

      if (!this.validateForm()) {
        return;
      }

      if (isNaN(this.form.id)) {
        this.createNewCategory();
      } else {
        this.updateCategory();
      }
    },

    validateForm() {
      if (!this.rules.alphabet(this.form.name)) {
        return false;
      }

      return true;
    },

    getCategories: debounce(async function() {
      try {
        this.loading = true;
        this.categories = undefined;

        const res = await api.getCategories({
          q: this.filters.q || undefined,
          page_size: this.pagination.rowsPerPage,
          page: this.pagination.page,
          with_complaint_natures: 1
        });

        this.categories = res.data.data;
        this.pagination.totalItems = res.data.total;
      } finally {
        this.loading = false;
      }
    }, 500),

    showNewCategoryForm() {
      this.resetForm();
      this.showDialog = true;
    },

    async createNewCategory() {
      try {
        this.updateLoading = true;

        await api.addCategories(this.form);

        this.$notify.success("Category has been added");
        this.resetForm();
        this.getCategories();

        this.showDialog = false;
      } catch (e) {
        console.error(e);

        if (e.errors) {
          this.errors = e.errors;
        } else {
          this.$notify.error(e.message);
        }
      } finally {
        this.updateLoading = false;
      }
    },

    async uploadImage(img) {
      try {
        this.iconUploading = true;

        const data = new FormData();
        data.set("file", img);
        data.set("name", img.name);

        const res = await api.uploadImage(data);

        this.form.icon = res.data.url;
      } catch (error) {
        this.$notify.error("Error upload");
      } finally {
        this.iconUploading = false;
      }
    },

    async updateCategory() {
      try {
        this.updateLoading = true;

        await api.updateCategories(this.form);

        this.$notify.success("Category has been updated");
        this.resetForm();
        this.getCategories();

        this.showDialog = false;
      } catch (e) {
        console.error(e);

        if (e.errors) {
          this.errors = e.errors;
        } else {
          this.$notify.error(e.message);
        }
      } finally {
        this.updateLoading = false;
      }
    },

    editItem(item) {
      this.currentCategoryComplaintNatures = toDictionary(
        item.complaint_natures
      );
      this.form = {
        id: item.id,
        name: item.name,
        icon: item.icon || undefined,
        department_id: item.department_id,
        complaint_nature_ids: item.complaint_natures.map(n => n.id)
      };

      // MUST Show Dialog after set current complaint natures & form
      this.showDialog = true;
    },

    async removeItem(item) {
      try {
        await this.$confirm(
          "This will permanently delete item. Continue?",
          "Warning",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning"
          }
        );
      } catch (error) {
        // Ignore
        return;
      }

      try {
        this.loading = true;

        await api.deleteCategory(item.id);

        this.getCategories();

        this.$notify.success("Deleted Category!");
      } finally {
        this.loading = false;
      }
    },

    async getDepartments() {
      const res = await api.getDepartments();

      this.departments = res.data.data;
    },

    async onAddComplaintNature(name) {
      try {
        this.natureLoading = true;

        const res = await api.addComplaintNature({
          name,
          category_id: this.form.id
        });

        this.$set(this.currentCategoryComplaintNatures, res.data.data.id, {
          id: res.data.data.id,
          name
        });
        this.form.complaint_nature_ids.push(res.data.data.id);
      } finally {
        this.natureLoading = false;
      }
    },

    async onEditComplaintNature(index, newName) {
      try {
        this.natureLoading = true;

        const id = this.form.complaint_nature_ids[index];

        await api.updateComplaintNature(id, {
          name: newName
        });

        this.currentCategoryComplaintNatures[id].name = newName;
      } finally {
        this.natureLoading = false;
      }
    },

    async onRemoveComplaintNature(index) {
      try {
        this.natureLoading = true;
        const id = this.form.complaint_nature_ids[index];

        await api.deleteComplaintNature(id);

        this.form.complaint_nature_ids.splice(index, 1);
        this.$delete(this.currentCategoryComplaintNatures, id);
      } finally {
        this.natureLoading = false;
      }
    },

    async deleteUncommitedComplaintNatures() {
      if (
        !this.form.complaint_nature_ids ||
        this.form.complaint_nature_ids.length === 0
      )
        return;

      this.form.complaint_nature_ids.forEach(id => {
        api.deleteComplaintNature(id);
      });
    }
  }
};
</script>

<style lang="css" scoped>
.form-item-view {
  display: flex;
  width: 100%;
  align-items: center;
}

.form-item-label {
  width: 10em;
  text-align: right;
  margin-right: 1.25em;
  /* margin-bottom: 1.25em; */
}

.full-height {
  flex: 1 1 auto;
  min-height: 0;
}

.scroll {
  overflow-y: auto;
}
</style>
